import React from "react";
import { Link } from "react-router-dom";

const BillingPlanPage = ({ plans }) => {
  return (
    <div className="get-plan-form bg-white mobile:h-screen tablet:h-full rounded-lg p-6 flex flex-col justify-center items-center">
      <div className="title-subtitle space-y-3">
        <h6 className="text-h6 text-dark4 text-center">Pricing plan</h6>
      </div>
      <div className="plans-list flex flex-col items-center space-y-9">
        {plans &&
          plans.length > 0 &&
          plans.map((plan) => (
            <div key={plan.id} className="plan-item text-center space-y-6">
              <h3 className="plan-name text-dark5 text-h6 font-semibold">{plan.name}</h3>
              <p className="plan-price text-dark5 text-bodyMR mt-0">Price: {plan.price / 100} $ / year</p>
              <div className="justify-center">
                <Link
                  key={plan.id}
                  className="flex items-center gap-3 rounded-[25px]  mobXS:w-full tabMD:w-1/2 desktop:w-full rounded-md bg-secondary justify-center text-white mobXS:py-[10px] mobXS:px-[24px] tabMD:py-[10px] tabMD:px-[24px]"
                  to={`/dashboard/billing/plans/checkout/${plan.plan_id}`}
                >
                  Get started today
                </Link>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default BillingPlanPage;
